import styled from "styled-components"
import { Layout } from "../components/common/Layout"
import Input from "../components/common/Input"
import { useEffect, useState } from "react"
import Button from "../components/common/Button"
import Spinner from "../components/common/Spinner"

const Form = styled.form`
  width: 100%;
  max-width: 400px;
  background: ${(p) => p.theme.formBackgroundColor};
  border: 1px solid #bbb;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #000;

  .or {
    margin: 10px 0;
    text-align: center;
  }

  ${Button}:first-of-type {
    margin-top: 40px;
  }
`

let timeout

function Login() {
  const [formFields, setFormFields] = useState({ user: "", pass: "" })
  const [loading, setLoading] = useState(false)

  function handleInput(e) {
    e.persist()
    setFormFields((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }))
  }

  function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    timeout = setTimeout(() => {
      setLoading(false)
    }, 1500)
  }

  useEffect(() => {
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [])

  return (
    <Layout>
      <h1>Login</h1>
      <Form onSubmit={handleSubmit}>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Input
              value={formFields.user}
              onChange={handleInput}
              type="text"
              name="user"
              placeholder="Username"
            />
            <Input
              value={formFields.pass}
              onChange={handleInput}
              type="password"
              name="pass"
              placeholder="Password"
            />
          </>
        )}

        <Button primary large disabled={loading} type="submit">
          {loading ? "Loading ..." : "Login"}
        </Button>
        {!loading && (
          <>
            <div className="or">or</div>
            <Button type="button">Register</Button>
          </>
        )}
      </Form>
    </Layout>
  )
}

export default Login
